import { useState, forwardRef, useImperativeHandle } from 'react';
import ShiftChangeForm from './ShiftChangeForm';

const ShiftChangeFormContainer = forwardRef((props, ref) => {

    const [isModalOpen, setIsModalOpen] = useState(false)
    const [isSubmitting, setIsSubmitting] = useState(false)

    const handleModalOpen = () => {
        setIsModalOpen(true)
    }

    const handleModalClose = () => {
        setIsModalOpen(false)
    }

    useImperativeHandle(ref, () => ({
        handleModalOpen
    }))

    // TODO: substituir pelo POST real (ex.: api.post('/createShiftChange', data)) quando o backend existir.
    const handleFormSubmit = async (data) => {

        setIsSubmitting(true)

        console.log('Passagem de turno (mock, sem persistência):', data)

        setIsSubmitting(false)
        handleModalClose()
    }

    return (

        <ShiftChangeForm
            isOpen={isModalOpen}
            onClose={handleModalClose}
            onSubmit={handleFormSubmit}
            isSubmitting={isSubmitting}
        />

    )
})

ShiftChangeFormContainer.displayName = 'ShiftChangeFormContainer'

export default ShiftChangeFormContainer
